<obg-m-suspicious-login-request-code
	*ngIf="currentStep === verifyLoginSteps.RequestCode"
	buttonText="suspicious-login.send-code"
	[communicationMethods]="challengeDetails?.communicationMethods"
	[showErrorMessage]="showErrorMessage"
	(submit)="onSendPin($event)"
>
</obg-m-suspicious-login-request-code>

<obg-m-suspicious-login-validate-code
	*ngIf="currentStep === verifyLoginSteps.ValidateCode"
	[showErrorMessage]="showErrorMessage"
	(resendPin)="onResendPin()"
	(validatePin)="onValidatePin($event)"
>
</obg-m-suspicious-login-validate-code>
